import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.readonly ? _c('div', [_c(VTextField, {
    class: _vm.required ? 'required' : '',
    attrs: {
      "value": _vm.readonlyName,
      "label": _vm.label || _vm.$i18n_t('Common.digitalTwins.searchLabel'),
      "placeholder": _vm.placeholder || (_vm.label ? '' : _vm.$i18n_t('Common.digitalTwins.searchPlaceholder')),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": _vm.hideDetails == true ? true : _vm.hideDetails,
      "dense": _vm.dense,
      "readonly": "",
      "disabled": "",
      "append-icon": _vm.appendIcon,
      "data-cy": "dtwin_finder_readonly"
    },
    scopedSlots: _vm._u([_vm.$slots['append-outer'] ? {
      key: "append-outer",
      fn: function () {
        return [_vm._t("append-outer")];
      },
      proxy: true
    } : null], null, true)
  })], 1) : _c('div', [_vm.treeMenu ? _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 10,
      "position-x": _vm.treeMenuPosition.x,
      "position-y": _vm.treeMenuPosition.y,
      "transition": "scale-transition",
      "offset-overflow": "",
      "min-width": "320px",
      "max-height": "500px"
    },
    model: {
      value: _vm.treeMenu,
      callback: function ($$v) {
        _vm.treeMenu = $$v;
      },
      expression: "treeMenu"
    }
  }, [_c(VCard, [_c('core-dtwin-tree-default', {
    attrs: {
      "userId": _vm.userId,
      "parentId": _vm.parentId,
      "tenantId": _vm.sameTenant ? (_vm.digitalTwin || {}).tenantId || _vm.tenantId : undefined,
      "activeDtwinId": _vm.digitalTwin ? _vm.digitalTwin.id : undefined,
      "openTreeNodes": _vm.digitalTwin ? [_vm.digitalTwin.id] : undefined,
      "searchEnabled": false,
      "selectionTagFilter": _vm.tagFilter,
      "selectionObjectFilter": _vm.objectFilter,
      "loadFullDtwinData": _vm.loadFullDtwinData
    },
    on: {
      "onSelectedChange": _vm.digitalTwinSelected
    }
  })], 1)], 1) : _vm._e(), _c(VTextField, {
    class: _vm.required ? 'required' : '',
    attrs: {
      "value": _vm.readonlyName,
      "label": _vm.label ? _vm.label : _vm.$i18n_t('Common.digitalTwins.searchLabel'),
      "placeholder": _vm.placeholder || (_vm.label ? '' : _vm.$i18n_t('Common.digitalTwins.searchPlaceholder')),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.disabled,
      "readonly": !_vm.disabled,
      "dense": _vm.dense,
      "hide-details": _vm.hideDetails == true ? true : _vm.hideDetails,
      "rules": _vm.required ? _vm.rules : _vm.noRules,
      "append-icon": "fal fa-angle-down",
      "data-cy": "dtwin_finder"
    },
    on: {
      "click": _vm.doOpenTree,
      "click:append": _vm.doOpenTree
    },
    scopedSlots: _vm._u([_vm.$slots['append-outer'] ? {
      key: "append-outer",
      fn: function () {
        return [_vm._t("append-outer")];
      },
      proxy: true
    } : null], null, true)
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };